"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _constants = require("../../constants");
var _excluded = ["autoFocus", "disabled", "readOnly", "block", "inputRef"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Input = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Input, _React$Component);
  var _super = _createSuper(Input);
  function Input() {
    var _this;
    (0, _classCallCheck2["default"])(this, Input);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function (evt) {
      if (_this.props.selectOnFocus) {
        evt.currentTarget.select();
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(Input, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        autoFocus = _this$props.autoFocus,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        block = _this$props.block,
        inputRef = _this$props.inputRef,
        otherProps = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var ComponentType = block ? BlockInputElem : InputElem;
      return /*#__PURE__*/React.createElement(ComponentType, (0, _extends2["default"])({
        ref: inputRef,
        autoFocus: autoFocus,
        onFocus: this.onFocus,
        disabled: disabled,
        readOnly: readOnly
      }, otherProps));
    }
  }]);
  return Input;
}(React.Component);
(0, _defineProperty2["default"])(Input, "defaultProps", {
  disabled: false,
  readOnly: false,
  block: false,
  inputRef: function inputRef() {},
  type: 'text',
  focusBorderColor: _constants.colors.mediumGreenhouseGreen,
  autoFocus: false,
  selectOnFocus: false
});
var InputElem = _styledComponents["default"].input.withConfig({
  displayName: "input__InputElem"
})(["&&&&{line-height:1.5;font-size:14px;color:", ";border:1px solid ", ";box-sizing:border-box;border-radius:2px;width:", ";padding:", " ", ";", " ", ";", " &:focus{", " border-color:", ";outline:none;}}"], _constants.colors.darkestGrey, _constants.colors.lightGrey, function (props) {
  return props.width || 'inherit';
}, _constants.padding.tiny, _constants.padding.small, /* @ts-expect-error Flow -> TS migration */'', (0, _polished.placeholder)({
  font: "".concat(_constants.fontWeight.normal, " 14px 'Untitled Sans Regular', sans-serif"),
  color: "".concat(_constants.colors.mediumGrey),
  'line-height': '1.5'
}), function (props) {
  return props.readOnly && (0, _styledComponents.css)(["background-color:", ";"], _constants.colors.lightestGrey);
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.focusBorderColor;
});
var BlockInputElem = (0, _styledComponents["default"])(InputElem).withConfig({
  displayName: "input__BlockInputElem"
})(["&&&&{display:block;width:100%;}"]);